import React, { Component } from "react";
import { Button } from "reactstrap";

export default class Hover extends Component {
    constructor(props){
        super(props);
        this.state = {
            showPopup: false,
            popupContent: ''
        };
    }

    formatDateTime = (dateTimeString) => {
        const dateTime = new Date(dateTimeString)
        const options = {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        };
        return new Intl.DateTimeFormat('de-DE', options).format(dateTime)
    }

    showInvitedAtPopup = (invitedAt) => {
        if (invitedAt != null){
            this.setState({showPopup: true})
            this.setState({popupContent: invitedAt})
        }
    }

    hideInvitedAtPopup = () => {
        this.setState({showPopup: false});
        this.setState({popupContent: ''})
    }

    render() {
        const {
            code,
            SendParticipantInvitation,
            enableEmailCodes,
            participantCodes,
            sendToParticipant,
            overview,
            isInvited,
            toggleSendModal
        } = this.props;

        return <div
            style={{
                position: 'relative',
                display: 'inline-block'
            }}
            >
                {
                    sendToParticipant ? (
                        <button
                            onMouseEnter={() => this.showInvitedAtPopup(code?.invited_at)}
                            onMouseLeave={this.hideInvitedAtPopup}
                            onClick={() => SendParticipantInvitation(code?.code)}
                            target="_blank"
                            referrerPolicy="no-referrer"
                            className={
                                enableEmailCodes.includes(code?.code) ? (
                                code?.is_invited ||
                                participantCodes.includes(code?.code)
                                ? "btn btn-success"
                                : "btn btn-primary")
                                : (
                                    "btn btn-secondary"
                                )
                            }
                            disabled={
                            !enableEmailCodes.includes(code?.code)
                            }>
                            <i className="fa fa-envelope"> </i>
                        </button>
                    ) : (
                        <div className="d-flex flex-column">
                            <p>
                                <strong>Verantwortliche Person: </strong>{overview?.contact_name} {overview?.contact && `(${overview.contact})`}
                            </p>
                            <Button
                                onMouseEnter={() => this.showInvitedAtPopup(overview?.contact_invited_at)}
                                onMouseLeave={this.hideInvitedAtPopup}
                                color={
                                    overview?.is_invited || isInvited
                                    ? "success"
                                    : "primary"
                                }
                                onClick={toggleSendModal}>
                                <i className="fa fa-envelope"> </i>
                                &nbsp; Einladung an Verantwortlichen senden
                            </Button>
                        </div>
                    )
                }

            {this.state.showPopup && (
                <div className="popup" style={{
                    position: 'absolute',
                    bottom: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    padding: '10px',
                    backgroundColor: 'black',
                    color: 'white',
                    borderRadius: '5px',
                    whiteSpace: 'nowrap'
                    }}
                >
                    {this.formatDateTime(this.state.popupContent)}
                </div>
        )}
        </div>
    }
}